import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Navigate } from 'react-router-dom';
import config from '../../configuration.json';
import Cookies from 'universal-cookie';
import Navbar from './play_Navbar';
import HeaderImage from './play_HeaderImage';
import Footer from './play_Footer';
import { setResultObject, setPromoState } from '../../actions';
import { ParticipationRegisterStatus } from './utils/ParticipationRegisterStatus';

// This comment is to avoid EsLint error for variable process
/* global process */

class PlayThankYou extends React.Component {

    state = {
        useNavigation: null,
        page: "Telepizza - Gracias"
    };

    componentDidMount() {
        window.scrollTo(0, 0);
        document.title = this.state.page;
        this.cookies = new Cookies();
        if (this.props.promoState !== ParticipationRegisterStatus.ParticipationDataRegistered){
            this.redirectHome();
        }
    }

    redirectHome = () => {
         window.gtag('event', 'GotoHome', { 'eventCategory': 'ThankYou', 'eventLabel': 'Boton_OK' });
        this.props.setPromoState(null);
        this.props.setResultObject(null);
        this.setState({ useNavigation: <Navigate to={`/${process.env.REACT_APP_HOME}`} replace={true} /> })
    }

    onActionClick = (e) => {
        const that = this;
        
        window.gtag('event', 'GotoFormData', { 'eventCategory': 'ThankYou', 'eventLabel': 'Boton_OK' });

        setTimeout(() => {
            if(config.PlayAndPizza.ThankYou.Copied.includes(this.props.result.prizeType)){
                window.location.href = config.PlayAndPizza.RedirectToPartner;
            }
            else{
                window.location.href = this.props.result.redirectThankyouPage + '/' + this.props.result.code;
            }
           
            //that.redirectHome();
        }, 500);

        e.preventDefault();
        e.stopPropagation();
    }
 async handleCopy(code) {
    try {
      await navigator.clipboard.writeText(code);
      this.setState({ copied: true });
 
    } catch (err) {
      console.error("Error al copiar:", err);
    }
  };

    render() {
        return (
            <div className='play_background' id='play_background'>
                {this.state.useNavigation}
                <Navbar image={config.PlayAndPizza.HeaderIconlUrl} />

                <div className='play_thankyou_container mx-auto text-center'>
                    <div className='play_thankyou_image_container'>
                        <img src={this.props.result.imgWin} alt="Thank You" />
                    </div>
                    <div>
                        <div dangerouslySetInnerHTML={{ __html: this.props.result.messageTitleWin }}></div>
                        <div className='play_thankyou_code mx-auto'>
                           {this.props.result.code}

                           {config.PlayAndPizza.ThankYou.Copied.includes(this.props.result.prizeType) ? <button onClick={() => this.handleCopy(this.props.result.code)} style={{ background: "none", border: "none", cursor: "pointer" }}>
                                    <span className="material-icons _copy" >
                                        {this.state.copied ? "check" : "content_copy"}
                                    </span>
                                </button> : <></>}
                        </div>
                    </div>
                    <div>
                        <button onClick={this.onActionClick} className="btn play_button">{config.PlayAndPizza.ThankYou[this.props.result.prizeType]}</button>
                    </div>
                    <div>
                        <div className='play_thankyou_detail mx-auto'>
                        <div
                            dangerouslySetInnerHTML={{ __html: this.props.result.messageTextWin }}
                        ></div>
                        </div>
    
                    </div>
                </div>

                <Footer footerName="thank-you-footer"/>
            </div>
        );
    }
}

PlayThankYou.propTypes = {
    result: PropTypes.object,
    promoState: PropTypes.string,
    setResultObject: PropTypes.func,
    setPromoState: PropTypes.func
};

const mapStateToProps = state => {
    return {
        result: state.pageReducer.result,
        promoState: state.pageReducer.promoState
        
    };
};

export default connect(mapStateToProps, { setResultObject, setPromoState })(PlayThankYou);